<arm-layout>
  <div main>
    <div class="alarms-advanced-container">
      <mat-expansion-panel *ngFor="let alarmType of alarmsTypes; let i = index"
                           [expanded]="alarmType.isOpen">
        <mat-expansion-panel-header expandedHeight="40px" collapsedHeight="40px">
          <mat-panel-title>
            <div class="title" title="{{alarmType.eventName}}">
              {{alarmType.eventName}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="form-table">
        </div>
        <arm-form (submitForm)="onSubmit(alarmType)" [disableSubmit]="isUnauthorized">

          <div class="enable-toggle">
            <mat-slide-toggle color="primary"
                              [checked]="alarmType.enabled"
                              (change)="alarmType.enabled = $event.checked">
              Add custom additional info
            </mat-slide-toggle>
          </div>

          <arm-form-title>General</arm-form-title>

          <div class="matching-general">
            <mat-form-field class="fullWidth">
              <mat-label>Request attribute to match</mat-label>
              <mat-select required [(ngModel)]="alarmType.matchingProperty" name="matchingProperty">
                <mat-option *ngFor="let matchingProperty of fieldToMatchOptions" [value]="matchingProperty.key">
                  {{matchingProperty.label}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="fullWidth">
              <mat-label>Match method</mat-label>
              <mat-select required [(ngModel)]="alarmType.matchingMethod" name="matchingMethod">
                <mat-option *ngFor="let matchingMethod of matchingMethodOptions" [value]="matchingMethod.key">
                  {{matchingMethod.label}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="fullWidth">
              <mat-label>User property to match</mat-label>
              <mat-select required [(ngModel)]="alarmType.matchedProperty" name="matchedProperty">
                <mat-option *ngFor="let matchedProperty of userPropertiesOptions" [value]="matchedProperty.key">
                  {{matchedProperty.label}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="guidelines-container">
            <p>* 'User property' is matched against 'Request attribute' before manipulation.</p>
          </div>

          <arm-form-title>Additional info pattern</arm-form-title>

          <div class="additional-info-pattern">
            <mat-label></mat-label>
            <nz-mention nzPlacement="top"
                        [nzSuggestions]="propertiesSuggestions"
                        [nzNotFoundContent]="'Property does not exist'">

                                          <textarea class="additional-info" maxlength="255"
                                                    placeholder="Call arrived from @[user_city] in @[user_country]"
                                                    nz-input [nzAutosize]="{ minRows: 2, maxRows: 2 }"
                                                    [(ngModel)]="alarmType.template"
                                                    nzMentionTrigger>
                                          </textarea>
              <ng-container *nzMentionSuggestion="let alarmType">
                <span>{{ alarmType.slice(1,-1) }}</span>
              </ng-container>
            </nz-mention>
          </div>

          <div class="guidelines-container">
            <p>* Press @ for properties options.</p>
            <p>* Only first 255 characters will be shown.</p>
          </div>


          <arm-form-title>Test</arm-form-title>

          <div class="test-section">
            <mat-form-field class="fullWidth">
              <mat-label>Test request attribute value</mat-label>
              <input matInput [(ngModel)]="alarmType.testValue" name="testValue" maxlength="255">
            </mat-form-field>

            <div class="test-template-button">
              <ac-button  (click)="testTemplate(alarmType)">Test</ac-button>
            </div>
          </div>

          <div class="test-result" [innerHTML]="testResult">
          </div>

        </arm-form>
      </mat-expansion-panel>
    </div>
  </div>
</arm-layout>
